module.exports = require("./file");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file3/index.js
 ** module id = 7
 ** module chunks = 0
 **/